import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'benefits-bar',
    templateUrl: './benefits-bar.component.html',
    styleUrls: ['./benefits-bar.component.less'],
    standalone: true
})
export class BenefitsBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
